export default {
  getRouterIndex () {
    return this.prefixRouter + '.index'
  },
  getRouterCreate () {
    return this.prefixRouter + '.create'
  },
  getRouterEdit () {
    return this.prefixRouter + '.edit'
  },

  getMessageConfirmation () {
    return {
      cancel: 'Não faça nada',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover esse registro?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/crud/resources/computed.js